import type { QuickSwitcherHandlerResponseBody } from '@swf/generated/types/api/sports';

import { defaultState } from '.';
import type { QuickSwitcherState } from './types';

export const reducers = {
  'page/_change': () => defaultState,
  loading: (state: QuickSwitcherState, payload = true): QuickSwitcherState => ({
    ...state,
    isLoading: payload
  }),
  dataLoadSuccess: (
    state: QuickSwitcherState,
    payload: QuickSwitcherHandlerResponseBody
  ): QuickSwitcherState => ({
    ...state,
    isLoading: false,
    data: payload
  }),
  navigating: (state: QuickSwitcherState, payload: boolean): QuickSwitcherState => ({
    ...state,
    isNavigating: payload
  })
};
